var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9226 11.0725L22.2664 20.2016C22.2615 20.2296 22.2462 20.2547 22.2236 20.2716C22.2011 20.2886 22.1729 20.2963 22.145 20.2929C22.1312 20.2949 22.1172 20.2941 22.1038 20.2906C22.0904 20.2871 22.0778 20.2809 22.0668 20.2724C22.0557 20.2639 22.0464 20.2532 22.0395 20.2411C22.0326 20.229 22.0281 20.2155 22.0264 20.2016L19.7936 12.4133C19.6804 12.0167 19.4421 11.6682 19.1149 11.4211C18.7878 11.1739 18.3897 11.0415 17.9813 11.044C17.571 11.0427 17.1717 11.1777 16.8448 11.4282C16.5178 11.6787 16.2814 12.0309 16.1719 12.4304L14.6503 17.7852C14.0237 19.7081 12.7817 20.4099 11.8275 20.2586C10.9242 20.1132 10.3371 19.2459 10.3371 18.0506V11.0725H8.58691V18.0506C8.58691 20.4527 10.0774 21.7593 11.5537 22.0046C13.2474 22.2899 15.3815 21.2458 16.3271 18.3187L17.8514 12.9154C17.8563 12.8838 17.8732 12.8555 17.8985 12.8363C17.9238 12.8171 17.9555 12.8087 17.987 12.8127C18.0172 12.8085 18.0478 12.8163 18.0725 12.8344C18.0972 12.8524 18.1141 12.8794 18.1196 12.9097L20.3496 20.6895C20.4612 21.0846 20.6975 21.4321 21.0227 21.6788C21.3479 21.9255 21.744 22.058 22.1506 22.056C22.5568 22.0582 22.9527 21.9262 23.2778 21.68C23.603 21.4338 23.8395 21.087 23.9515 20.6923L26.7462 11.0725H24.9226Z",
    fill: "#5F80F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a509a4f6.svg";
export { ForwardRef as ReactComponent };